// extracted by mini-css-extract-plugin
module.exports = {"Item":"Item_Item__3LwJ8","Image":"Item_Image__e_Jlt"};